import { CheckIfUserHasApiPrivilege } from '../../../../common/client-status';

import { Product, ProductCard } from './interfaces';
import { productsAndServicesConfig as productsAndServicesInitConfig } from './config';

const getStateOfProductsAndServices = (
  products: Product[],
  checkIfUserHasApiPrivilege: CheckIfUserHasApiPrivilege
): ProductCard[] =>
  products.map(({ apiPrivilege, ...rest }: Product) => ({
    ...rest,
    isActive: checkIfUserHasApiPrivilege(apiPrivilege)
  }));

export const productsAndServicesConfig = (checkIfUserHasApiPrivilege: CheckIfUserHasApiPrivilege) =>
  productsAndServicesInitConfig.map(({ title, products }) => ({
    title,
    products: getStateOfProductsAndServices(products, checkIfUserHasApiPrivilege)
  }));
